<template>
  <div class="chart-container">
    <Pie v-if="chartReady" :data="pieChartData" :options="chartOptions" />
    <div v-else>Loading chart...</div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Pie } from "vue-chartjs";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  ArcElement,
  CategoryScale,
} from "chart.js";
import { EMAIL_TYPES } from "../../constants";

ChartJS.register(Title, Tooltip, Legend, ArcElement, CategoryScale);

export default defineComponent({
  name: "PieChartType",
  components: { Pie },
  props: {
    chartData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      EMAIL_TYPES,
      chartReady: false,
      pieChartData: {
        labels: [],
        datasets: [
          {
            backgroundColor: [],
            data: [],
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: {
            position: "top",
          },
          title: {
            display: true,
            text: "Distribution of Email by Type",
            font: {
              size: 16,
            },
          },
        },
      },
    };
  },
  methods: {
    getColor(type) {
      return (
        EMAIL_TYPES.find((p) => p.id === type).color ||
        "#" + Math.floor(Math.random() * 16777215).toString(16)
      );
    },
    prepareChartData() {
      const languageTotals = this.chartData.reduce((acc, item) => {
        const type = item._id.type;
        if (!acc[type]) {
          acc[type] = 0;
        }
        acc[type] += item.count;
        return acc;
      }, {});

      const labels = Object.keys(languageTotals);
      const data = Object.values(languageTotals);
      const backgroundColor = labels.map(this.getColor);

      this.pieChartData = {
        labels,
        datasets: [
          {
            backgroundColor,
            data,
          },
        ],
      };

      this.chartReady = true;
    },
  },
  watch: {
    chartData: {
      handler() {
        this.prepareChartData();
      },
      immediate: true,
      deep: true,
    },
  },
});
</script>

<style scoped>
.chart-container {
  height: 400px;
  width: 100%;
}
</style>
